// A ClickHouse profileId is `profile/<domainId>/<userId>`. The bare userId is
// what the merchant supplied, so it can itself contain '/' — rejoin the tail
// rather than taking `split('/')[2]`, which would truncate it silently.
// Mirrors magellan-api's `getUserIdFromProfileId` in `helpers/profile-id-helper.js`.
export const getUserIdFromProfileId = (profileId) => (profileId || '').split('/').slice(2).join('/');
